import { PrimitiveValueObjectDate } from '@/domain/primitiveValueObjectDate';

/**
 * 欠席日
 */
export class AttendanceDate extends PrimitiveValueObjectDate {
  /**
   * 作成
   * @param value 値
   * @returns 値
   */
  static create(value: Date): AttendanceDate {
    return new AttendanceDate(value);
  }

  /** ラベル */
  static get label(): string {
    return '日付';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /** 日付 */
  get date(): string {
    return this.value.toISOString().split('T')[0];
  }

  /**
   * 現在の日
   */
  static get currentDate(): string {
    return (new Date()).toISOString().split('T')[0];
  }
}
